import React, { useEffect, useState, createElement } from 'react';
export function ProductPage() {
  // Dynamic visitor count that changes between 1000-1600
  const [visitorCount, setVisitorCount] = useState(1085);
  // Rotating promo messages
  const promoMessages = ['❤️ 47% OFF - LIMITED TIME ❤️', '🔥 BUY MORE SAVE MORE 🔥', '⚡ INSTANT DIGITAL DOWNLOAD ⚡', '🎉 FREE BONUS RECIPES INCLUDED 🎉', '💪 JOIN 6,000+ HAPPY CUSTOMERS 💪'];
  const [currentPromoIndex, setCurrentPromoIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  // Load tracking scripts for Meta/UTMify
  useEffect(() => {
    // UTMify UTMs script
    const utmScript = document.createElement('script');
    utmScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
    utmScript.setAttribute('data-utmify-prevent-subids', '');
    utmScript.async = true;
    utmScript.defer = true;
    document.head.appendChild(utmScript);
    (window as any).pixelId = '69744866af48a876a5c28040';
    const pixelScript = document.createElement('script');
    pixelScript.async = true;
    pixelScript.defer = true;
    pixelScript.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
    document.head.appendChild(pixelScript);
    // Cleanup on unmount
    return () => {
      document.head.removeChild(utmScript);
      document.head.removeChild(pixelScript);
    };
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      // Generate random number between 1000 and 1600
      const newCount = Math.floor(Math.random() * (1600 - 1000 + 1)) + 1000;
      setVisitorCount(newCount);
    }, 3000); // Changes every 3 seconds
    return () => clearInterval(interval);
  }, []);
  // Rotate promo messages
  useEffect(() => {
    const promoInterval = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentPromoIndex(prev => (prev + 1) % promoMessages.length);
        setIsAnimating(false);
      }, 300);
    }, 3500);
    return () => clearInterval(promoInterval);
  }, []);
  // Smooth scroll to CTA section
  const scrollToCTA = () => {
    const ctaSection = document.getElementById('cta-section');
    if (ctaSection) {
      ctaSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  // Colors from CSS variables
  const colors = {
    primaryRed: '#d34a4a',
    primaryOrange: '#ff7729',
    textDark: '#2f2f2f',
    bgLight: '#f9f9f9'
  };
  return <>
      {/* Sticky Promo Banner */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-[#6bb3c9] text-white py-[10px] px-[20px] text-center font-bold text-[14px] shadow-md" data-id="element-3">
        <div className={`transition-all duration-300 ${isAnimating ? 'opacity-0 translate-y-[-10px]' : 'opacity-100 translate-y-0'}`} data-id="element-4">
          {promoMessages[currentPromoIndex]}
        </div>
      </div>

      <div className="max-w-[800px] mx-auto p-5 pt-[60px] font-['Merriweather'] text-[#2f2f2f] leading-[1.6]" data-id="element-5">
        {/* Header */}
        <h1 className="text-[38px] max-sm:text-[28px] text-center leading-[1.2] mb-[10px] font-[800]" data-id="element-6">
          🔥 The First "Body-Clock" Aligned Mediterranean 3-Pack: Food Chart,
          Circadian Guide & 2026 Meal Plan
        </h1>

        <p className="text-[22px] text-center text-[#666] mb-[40px] italic" data-id="element-7">
          Discover why eating the right food at the <strong data-id="element-8">wrong time</strong>{' '}
          might be the only thing standing between you and your health goals.
        </p>

        <img src="https://cdn.magicpatterns.com/uploads/9HUXzCc4dN8j8JLF7rHBxU/253d3c2f-590e-45f9-8003-59c5edaba256.png" alt="Mediterranean 3-Pack Bundle" className="w-full h-auto rounded-[8px] bg-[#eee] block mb-[30px] aspect-square object-cover" data-id="element-9" />

        {/* Product Info & Pricing */}
        <div className="mb-[40px]" data-id="element-10">
          {/* Product Title */}
          <h2 className="text-[20px] font-bold text-[#2f2f2f] mb-[15px] leading-[1.3]" data-id="element-11">
            🔥 3-Pack Mediterranean Diet Chart Food List 2026, Mediterranean
            Ingredient Meal Plan
          </h2>

          {/* Pricing */}
          <div className="flex items-center gap-[12px] mb-[20px] flex-wrap" data-id="element-12">
            <span className="text-[32px] font-bold text-[#d34a4a]" data-id="element-13">£9.10</span>
            <span className="text-[20px] font-bold text-[#666] line-through" data-id="element-14">
              £17.10
            </span>
            <span className="bg-[#d34a4a] text-white px-[12px] py-[4px] text-[14px] font-bold rounded" data-id="element-15">
              Save 47%
            </span>
          </div>

          {/* Visitors Banner */}
          <div className="bg-[#8bc34a] text-white px-[16px] py-[10px] rounded-[5px] mb-[12px] text-[15px] font-medium" data-id="element-16">
            👁️ {visitorCount} visitors currently looking at this product
          </div>

          {/* Facebook Recommendations */}
          <div className="flex items-start gap-[8px] mb-[12px] text-[14px] text-[#555]" data-id="element-17">
            <span className="text-[16px]" data-id="element-18">🌐</span>
            <span data-id="element-19">It's been recommended by 6.19K people on Facebook</span>
          </div>

          {/* Digital Product Notice */}
          <div className="flex items-start gap-[8px] text-[14px] text-[#555] bg-[#f0f8ff] px-[12px] py-[8px] rounded-[5px] border border-[#d0e8ff] mb-[20px]" data-id="element-20">
            <span className="text-[16px]" data-id="element-21">📱</span>
            <span data-id="element-22">Digital download - Instant access after purchase</span>
          </div>

          {/* Buy It Now Button */}
          <button onClick={scrollToCTA} className="w-full bg-[#ff7729] text-white py-[16px] px-[30px] text-[18px] font-bold uppercase rounded-[5px] shadow-[0_4px_15px_rgba(255,119,41,0.4)] transition-all hover:scale-[1.02] hover:shadow-[0_6px_20px_rgba(255,119,41,0.5)]" data-id="element-23">
            BUY IT NOW
          </button>
        </div>

        {/* Hook Box */}
        <div className="text-[18px] border-l-[5px] border-[#ff7729] pl-[20px] my-[40px]" data-id="element-24">
          Most standard cookbooks give you a list of healthy ingredients and
          wish you luck. They tell you to eat healthy fats and grains, but they
          miss the{' '}
          <span className="font-bold text-[#d34a4a]" data-id="element-25">ancient secret</span> that
          makes the Mediterranean lifestyle so effective:{' '}
          <strong data-id="element-26">Timing.</strong>
        </div>

        <img src="https://cdn.magicpatterns.com/uploads/7mAY7yyCK9KPTzsLJB7w9g/mediterranean_recipes.png" alt="Mediterranean Recipes" className="w-full h-auto rounded-[8px] mb-[40px]" data-id="element-27" />

        {/* Benefits */}
        <div className="mb-[35px]" data-id="element-28">
          <h2 className="text-[24px] text-[#111] flex items-center gap-[10px] mb-[10px] font-bold" data-id="element-29">
            🌞 The "Sunrise-to-Sunset" Nutrition Guide
          </h2>
          <p className="text-[16px] text-[#444]" data-id="element-30">
            Stop guessing. Our chart categorizes foods not just by type, but by
            the <strong data-id="element-31">optimal time to eat them</strong>. Learn which healthy
            carbs fuel your morning focus and which calming ingredients prepare
            your body for deep rest at night. Standard charts don't show you
            this.
          </p>

          <img src="https://cdn.magicpatterns.com/uploads/jn9gBskE8n9PW5LaeLSPUc/4d02fb1a-2ea6-4eff-ac6b-0e4d5e0a20de.png" alt="Sunrise-to-Sunset Nutrition Guide" className="w-full h-auto rounded-[8px] mt-[20px]" data-id="element-32" />
        </div>

        <div className="mb-[35px]" data-id="element-33">
          <h2 className="text-[24px] text-[#111] flex items-center gap-[10px] mb-[10px] font-bold" data-id="element-34">
            🥗 Metabolic Harmony & Wellness
          </h2>

          <img src="https://cdn.magicpatterns.com/uploads/kNQhXCeNUpewei5XpQHQaA/c24ae4c5-08c5-443a-914f-547c37cc0e61.png" alt="Optimise Your Health with Body-Clock Aligned Mediterranean Nutrition" className="w-full h-auto rounded-[8px] mb-[10px]" data-id="element-35" />

          <p className="text-[16px] text-[#444]" data-id="element-36">
            Ideal for anyone looking to support healthy blood sugar and
            cholesterol levels naturally. By distributing nutrients according to
            our <strong data-id="element-37">"Circadian Meal Plan,"</strong> you help your body
            process food efficiently, avoiding the late-night spikes that
            standard diets often overlook.
          </p>
        </div>

        <div className="mb-[35px]" data-id="element-38">
          <h2 className="text-[24px] text-[#111] flex items-center gap-[10px] mb-[10px] font-bold" data-id="element-39">
            ⏱️ 30-Minute "Sync" Recipes
          </h2>
          <p className="text-[16px] text-[#444]" data-id="element-40">
            Healthy doesn't mean slow. Enjoy delicious, authentic Mediterranean
            recipes designed to be prepped in 30 minutes or less. Each recipe is
            tagged with a "Best Time to Eat" icon, making it effortless to stay
            in sync with your biology.
          </p>

          <img src="https://cdn.magicpatterns.com/uploads/vUqD2ynWEhufzSEjZckYft/bb6318c4-ce10-4753-b696-3a61d2076ee8.png" alt="Healthy Eating, Perfectly Timed with Your Body Clock" className="w-full h-auto rounded-[8px] mt-[20px]" data-id="element-41" />
        </div>

        {/* Specs Box */}
        <div className="bg-[#f9f9f9] p-[25px] rounded-[10px] border border-[#ddd] my-[40px]" data-id="element-42">
          <h3 className="text-[1.17em] font-bold mb-4" data-id="element-43">Product Information</h3>
          <ul className="list-none p-0 m-0" data-id="element-44">
            <li className="mb-[8px] text-[15px]" data-id="element-45">
              <strong data-id="element-46">Format:</strong> 3-Pack Bundle (Easy-Reference Chart +
              Meal Plan + Food List)
            </li>
            <li className="mb-[8px] text-[15px]" data-id="element-47">
              <strong data-id="element-48">Edition:</strong> 2026 Updated "Circadian" Version
            </li>
          </ul>
        </div>

        {/* CTA */}
        <div id="cta-section" className="my-[50px]" data-id="element-49">
          <p className="mb-4 text-center" data-id="element-50">
            ❤️ Thank you for visiting! We are excited to help you sync your
            health with nature ❤️
          </p>

          {/* Pricing Card */}
          <div className="bg-gradient-to-b from-[#fff8f0] to-white border-2 border-[#ff7729] rounded-[16px] p-[30px] shadow-[0_8px_30px_rgba(255,119,41,0.15)] text-center" data-id="element-51">
            {/* Product Name */}
            <h3 className="text-[22px] font-bold text-[#2f2f2f] mb-[20px] leading-[1.3]" data-id="element-52">
              Mediterranean 3-Pack is made for you.
            </h3>

            {/* Old Price */}
            <p className="text-[18px] text-[#999] line-through mb-[5px]" data-id="element-53">
              £17.10
            </p>

            {/* Current Price */}
            <p className="text-[52px] font-bold text-[#ff7729] mb-[15px] leading-none" data-id="element-54">
              £9.10
            </p>

            {/* Discount Badge */}
            <div className="inline-block bg-[#8bc34a] text-white px-[20px] py-[8px] rounded-full text-[16px] font-bold mb-[25px]" data-id="element-55">
              -47% WINTER SALE
            </div>

            {/* Benefits List */}
            <div className="text-left max-w-[320px] mx-auto mb-[25px]" data-id="element-56">
              <div className="flex items-start gap-[10px] mb-[12px] text-[15px] text-[#555]" data-id="element-57">
                <span className="text-[#ff7729] font-bold" data-id="element-58">✓</span>
                <span data-id="element-59">Discover the guide that decides for you</span>
              </div>
              <div className="flex items-start gap-[10px] mb-[12px] text-[15px] text-[#555]" data-id="element-60">
                <span className="text-[#ff7729] font-bold" data-id="element-61">✓</span>
                <span data-id="element-62">Access your permanent Plan B</span>
              </div>
              <div className="flex items-start gap-[10px] mb-[12px] text-[15px] text-[#555]" data-id="element-63">
                <span className="text-[#ff7729] font-bold" data-id="element-64">✓</span>
                <span data-id="element-65">Free yourself from mental load tonight</span>
              </div>
            </div>

            {/* CTA Button */}
            <a href="https://pay.hotmart.com/N104139877W?off=a5d8ca89&checkoutMode=10" target="_blank" rel="noopener noreferrer" className="w-full bg-[#ff7729] text-white py-[18px] px-[40px] text-[18px] font-bold uppercase rounded-[8px] inline-block shadow-[0_4px_15px_rgba(255,119,41,0.4)] transition-all hover:scale-[1.02] hover:shadow-[0_6px_20px_rgba(255,119,41,0.5)] no-underline" data-id="element-66">
              👉 CLICK TO ADD TO CART & START NOW!
            </a>

            {/* Subtext */}
            <p className="text-[13px] text-[#888] mt-[15px] italic" data-id="element-67">
              Click now and transform your health with the Mediterranean
              lifestyle.
            </p>
          </div>
        </div>

        {/* Testimonials Section */}
        <div className="my-[50px]" data-id="element-68">
          <h2 className="text-[28px] font-bold text-center text-[#2f2f2f] mb-[30px]" data-id="element-69">
            ⭐ What Our Customers Say
          </h2>

          <div className="space-y-[20px]" data-id="element-70">
            {/* Testimonial 1 - with image */}
            <div className="bg-white border border-[#eee] rounded-[12px] p-[20px] shadow-sm" data-id="element-71">
              <div className="flex items-center gap-[12px] mb-[12px]" data-id="element-72">
                <div className="w-[40px] h-[40px] bg-[#e8e8e8] rounded-full flex items-center justify-center text-[16px] font-bold text-[#666]" data-id="element-73">
                  S.H.
                </div>
                <div data-id="element-74">
                  <p className="font-bold text-[15px] text-[#333]" data-id="element-75">Sarah H.</p>
                  <p className="text-[12px] text-[#888]" data-id="element-76">
                    Reviewed in the United Kingdom
                  </p>
                </div>
              </div>
              <div className="text-[#ff9900] text-[16px] mb-[10px]" data-id="element-77">★★★★★</div>
              <p className="text-[14px] text-[#444] leading-[1.6] mb-[15px]" data-id="element-78">
                Absolutely brilliant! I've tried so many diet plans before, but
                this is the first one that actually makes sense. The timing
                aspect is a game-changer. I've printed the food chart and stuck
                it on my fridge. My energy levels have improved massively since
                following the circadian meal plan. Worth every penny!
              </p>
              <img src="https://cdn.magicpatterns.com/uploads/dBkatvXv4BztAdeNHvEECs/Gemini_Generated_Image_1abirt1abirt1abi_-_Editado.png" alt="Customer's Mediterranean salad" className="w-full max-w-[300px] h-auto rounded-[8px]" data-id="element-79" />
            </div>

            {/* Testimonial 2 */}
            <div className="bg-white border border-[#eee] rounded-[12px] p-[20px] shadow-sm" data-id="element-80">
              <div className="flex items-center gap-[12px] mb-[12px]" data-id="element-81">
                <div className="w-[40px] h-[40px] bg-[#e8e8e8] rounded-full flex items-center justify-center text-[16px] font-bold text-[#666]" data-id="element-82">
                  J.M.
                </div>
                <div data-id="element-83">
                  <p className="font-bold text-[15px] text-[#333]" data-id="element-84">James M.</p>
                  <p className="text-[12px] text-[#888]" data-id="element-85">
                    Reviewed in the United Kingdom
                  </p>
                </div>
              </div>
              <div className="text-[#ff9900] text-[16px] mb-[10px]" data-id="element-86">★★★★★</div>
              <p className="text-[14px] text-[#444] leading-[1.6]" data-id="element-87">
                Downloaded it instantly and had it printed within minutes. The
                layout is really clear and easy to follow. My wife and I have
                been using it for three weeks now and we both feel so much
                better. The "best time to eat" icons are genuinely helpful.
                Highly recommend!
              </p>
            </div>

            {/* Testimonial 3 - with image */}
            <div className="bg-white border border-[#eee] rounded-[12px] p-[20px] shadow-sm" data-id="element-88">
              <div className="flex items-center gap-[12px] mb-[12px]" data-id="element-89">
                <div className="w-[40px] h-[40px] bg-[#e8e8e8] rounded-full flex items-center justify-center text-[16px] font-bold text-[#666]" data-id="element-90">
                  E.T.
                </div>
                <div data-id="element-91">
                  <p className="font-bold text-[15px] text-[#333]" data-id="element-92">Emma T.</p>
                  <p className="text-[12px] text-[#888]" data-id="element-93">
                    Reviewed in the United Kingdom
                  </p>
                </div>
              </div>
              <div className="text-[#ff9900] text-[16px] mb-[10px]" data-id="element-94">★★★★★</div>
              <p className="text-[14px] text-[#444] leading-[1.6] mb-[15px]" data-id="element-95">
                I was sceptical at first, but this has completely changed how I
                think about food. The recipes are delicious and genuinely quick
                to make. Made this lovely fish dish last night following the
                evening meal suggestions - my family loved it! The digital
                format is so convenient.
              </p>
              <img src="https://cdn.magicpatterns.com/uploads/rg8PGR95KL7RxUc3PFeyEW/Diseno_sin_titulo_(5).png" alt="Customer's Mediterranean fish dish" className="w-full max-w-[300px] h-auto rounded-[8px]" data-id="element-96" />
            </div>

            {/* Testimonial 4 */}
            <div className="bg-white border border-[#eee] rounded-[12px] p-[20px] shadow-sm" data-id="element-97">
              <div className="flex items-center gap-[12px] mb-[12px]" data-id="element-98">
                <div className="w-[40px] h-[40px] bg-[#e8e8e8] rounded-full flex items-center justify-center text-[16px] font-bold text-[#666]" data-id="element-99">
                  D.W.
                </div>
                <div data-id="element-100">
                  <p className="font-bold text-[15px] text-[#333]" data-id="element-101">David W.</p>
                  <p className="text-[12px] text-[#888]" data-id="element-102">
                    Reviewed in the United Kingdom
                  </p>
                </div>
              </div>
              <div className="text-[#ff9900] text-[16px] mb-[10px]" data-id="element-103">★★★★★</div>
              <p className="text-[14px] text-[#444] leading-[1.6]" data-id="element-104">
                Fantastic value for money. I've spent hundreds on nutrition
                books over the years, but this simple 3-pack has been more
                useful than all of them combined. The body-clock approach just
                clicks. My afternoon slumps have disappeared since I started
                eating according to the chart.
              </p>
            </div>

            {/* Testimonial 5 */}
            <div className="bg-white border border-[#eee] rounded-[12px] p-[20px] shadow-sm" data-id="element-105">
              <div className="flex items-center gap-[12px] mb-[12px]" data-id="element-106">
                <div className="w-[40px] h-[40px] bg-[#e8e8e8] rounded-full flex items-center justify-center text-[16px] font-bold text-[#666]" data-id="element-107">
                  L.P.
                </div>
                <div data-id="element-108">
                  <p className="font-bold text-[15px] text-[#333]" data-id="element-109">Lucy P.</p>
                  <p className="text-[12px] text-[#888]" data-id="element-110">
                    Reviewed in the United Kingdom
                  </p>
                </div>
              </div>
              <div className="text-[#ff9900] text-[16px] mb-[10px]" data-id="element-111">★★★★★</div>
              <p className="text-[14px] text-[#444] leading-[1.6]" data-id="element-112">
                Love that it's a digital download - got it straight away! The
                meal plan is so well organised and the food chart is now
                laminated and hanging in my kitchen. It's taken all the
                guesswork out of healthy eating. My sleep has improved too since
                following the evening food suggestions.
              </p>
            </div>

            {/* Testimonial 6 */}
            <div className="bg-white border border-[#eee] rounded-[12px] p-[20px] shadow-sm" data-id="element-113">
              <div className="flex items-center gap-[12px] mb-[12px]" data-id="element-114">
                <div className="w-[40px] h-[40px] bg-[#e8e8e8] rounded-full flex items-center justify-center text-[16px] font-bold text-[#666]" data-id="element-115">
                  R.C.
                </div>
                <div data-id="element-116">
                  <p className="font-bold text-[15px] text-[#333]" data-id="element-117">Robert C.</p>
                  <p className="text-[12px] text-[#888]" data-id="element-118">
                    Reviewed in the United Kingdom
                  </p>
                </div>
              </div>
              <div className="text-[#ff9900] text-[16px] mb-[10px]" data-id="element-119">★★★★★</div>
              <p className="text-[14px] text-[#444] leading-[1.6]" data-id="element-120">
                Bought this for my mum as she's been wanting to eat healthier.
                She rang me the next day absolutely chuffed with it! She said
                it's the clearest, most practical guide she's ever seen. Now
                she's telling all her friends about it. Brilliant product, thank
                you!
              </p>
            </div>
          </div>

          {/* I Want The Same Results Button */}
          <div className="text-center mt-[30px]" data-id="element-121">
            <button onClick={scrollToCTA} className="bg-[#ff7729] text-white py-[16px] px-[40px] text-[18px] font-bold rounded-full shadow-[0_4px_15px_rgba(255,119,41,0.4)] transition-all hover:scale-[1.02] hover:shadow-[0_6px_20px_rgba(255,119,41,0.5)] inline-flex items-center gap-[8px]" data-id="element-122">
              I Want The Same Results
              <span className="text-[20px]" data-id="element-123">›</span>
            </button>
          </div>
        </div>

        {/* Trust Grid */}
        <div className="grid grid-cols-2 max-sm:grid-cols-1 gap-[20px] mt-[50px] border-t border-[#eee] pt-[30px]" data-id="element-124">
          <div className="trust-item" data-id="element-125">
            <h4 className="text-[16px] mb-[5px] text-[#111] font-bold" data-id="element-126">
              ⚡ Instant Access
            </h4>
            <p className="text-[13px] text-[#777]" data-id="element-127">
              Download immediately after purchase. No waiting, no shipping
              delays. Start your journey today.
            </p>
          </div>
          <div className="trust-item" data-id="element-128">
            <h4 className="text-[16px] mb-[5px] text-[#111] font-bold" data-id="element-129">
              📧 Delivered to Your Inbox
            </h4>
            <p className="text-[13px] text-[#777]" data-id="element-130">
              Receive your files directly via email. Access them anytime,
              anywhere, on any device.
            </p>
          </div>
          <div className="trust-item" data-id="element-131">
            <h4 className="text-[16px] mb-[5px] text-[#111] font-bold" data-id="element-132">
              🖨️ Print at Home
            </h4>
            <p className="text-[13px] text-[#777]" data-id="element-133">
              High-quality PDF format. Print as many copies as you like for
              personal use.
            </p>
          </div>
          <div className="trust-item" data-id="element-134">
            <h4 className="text-[16px] mb-[5px] text-[#111] font-bold" data-id="element-135">
              ♾️ Lifetime Access
            </h4>
            <p className="text-[13px] text-[#777]" data-id="element-136">
              One-time purchase, yours forever. No subscriptions, no hidden
              fees. Download again anytime.
            </p>
          </div>
        </div>
      </div>
    </>;
}